import { render, staticRenderFns } from "./CarView.vue?vue&type=template&id=fed1048c&scoped=true&"
import script from "./CarView.vue?vue&type=script&lang=js&"
export * from "./CarView.vue?vue&type=script&lang=js&"
import style0 from "./CarView.vue?vue&type=style&index=0&id=fed1048c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed1048c",
  null
  
)

export default component.exports